import styles from './empty.module.sass';
import cn from 'classnames';
import withResponsiveStyles from '../hocs/ResponiseStyles/withResponsiveStyles';
import { Skeleton } from '../Skeleton';

interface EmptyDataProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const OriginalEmptyData = ({ children, ...props }: EmptyDataProps) => {
    return (
        <div {...props} className={cn(styles.empty, props.className)}>
            <Skeleton absolute />
            {children}
        </div>
    );
};

const EmptyData = withResponsiveStyles(OriginalEmptyData);
export { EmptyData };
